import React from "react";

import { Box, Heading } from "../elements";
import { ActionButton, InputField } from "../v3";

export const AddItem = ({ item, onChange, onSubmit }) => {
  return (
    <Box>
      <Heading as="h5" className="textAlignLeft" style={{ marginBottom: 16 }}>
        Add Item
      </Heading>
      <Box className="fl gap-2">
        <InputField label="Name" name="name" value={item.name} onChange={onChange} style={{ width: "100%", marginBottom: 3 }} />
        <InputField
          label="Quantity"
          name="quantity"
          value={item.quantity}
          onChange={onChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
        <InputField
          label="Price"
          name="price"
          value={item.price}
          onChange={onChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
      </Box>

      <ActionButton buttonText="Add" color="primary" onButtonClick={onSubmit} />
    </Box>
  );
};
